import axios from "axios";

export const GET_ALL = "agents-catalog";
export const GET_BY_AGENT_ID = "agents-catalog";

export let getAll = function () {
  return axios.get(`${GET_ALL}`);
}

export let getByAgentId = function (agentId) {
  return axios.get(`${GET_BY_AGENT_ID}/${agentId}`);
}
